import { UserDto, AdminUserDto, ContractorAdminDto, ContractorAdminDetailDto, PagedResult } from '../types/admin';
import apiClient from './client';

export interface GetUsersParams {
  searchTerm?: string;
  isContractor?: boolean;
  isAdmin?: boolean;
  page?: number;
  pageSize?: number;
}

export interface GetContractorsAdminParams {
  searchTerm?: string;
  isVerified?: boolean;
  isFeatured?: boolean;
  tier?: number;
  page?: number;
  pageSize?: number;
}

export async function getAllUsers(params: GetUsersParams = {}): Promise<PagedResult<UserDto>> {
  const response = await apiClient.get<PagedResult<UserDto>>('/Admin/users', { params });
  return response.data;
}

export async function getAllContractorsAdmin(params: GetContractorsAdminParams = {}): Promise<PagedResult<ContractorAdminDto>> {
  const response = await apiClient.get<PagedResult<ContractorAdminDto>>('/Admin/contractors', { params });
  return response.data;
}

export async function updateUserRole(userId: string, isAdmin?: boolean, isContractor?: boolean): Promise<boolean> {
  const response = await apiClient.put<boolean>(`/Admin/users/${userId}/role`, { userId, isAdmin, isContractor });
  return response.data;
}

export async function verifyContractor(contractorProfileId: number, isVerified: boolean, status?: string): Promise<boolean> {
  const response = await apiClient.put<boolean>(`/Admin/contractors/${contractorProfileId}/verify`, { contractorProfileId, isVerified, status });
  return response.data;
}

export async function setFeaturedContractor(contractorProfileId: number, isFeatured: boolean): Promise<void> {
  await apiClient.put(`/Admin/contractors/${contractorProfileId}/featured`, { isFeatured });
}

export async function getContractorAdminDetail(contractorProfileId: number): Promise<ContractorAdminDetailDto> {
  const response = await apiClient.get<ContractorAdminDetailDto>(`/Admin/contractors/${contractorProfileId}`);
  return response.data;
}

export async function reviewCredential(
  credentialId: number,
  newStatus: 'Confirmed' | 'Rejected',
  rejectionReason?: string
): Promise<void> {
  await apiClient.put(`/Admin/credentials/${credentialId}/review`, { newStatus, rejectionReason });
}

export async function setContractorTier(contractorProfileId: number, tier: number | null): Promise<void> {
  await apiClient.put(`/Admin/contractors/${contractorProfileId}/tier`, { tier });
}

export async function getAdminUsers(): Promise<AdminUserDto[]> {
  const response = await apiClient.get<AdminUserDto[]>('/Admin/users/admins');
  return response.data;
}

export async function grantModeratorRole(userId: string): Promise<void> {
  await apiClient.post(`/Admin/users/${userId}/moderator`);
}

export async function revokeModeratorRole(userId: string): Promise<void> {
  await apiClient.delete(`/Admin/users/${userId}/moderator`);
}
